import apiClient from './client';

/**
 * GET /api/cases/:caseNumber/verifications
 */
export const fetchCaseVerifications = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/verifications`);
  return data; // { verifications: [...], total, summary: { pass, warn, fail } }
};
